import { render, staticRenderFns } from "./RecaptchaNotice.vue?vue&type=template&id=5f45811f&scoped=true"
import script from "./RecaptchaNotice.vue?vue&type=script&lang=js"
export * from "./RecaptchaNotice.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaNotice.vue?vue&type=style&index=0&id=5f45811f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45811f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f45811f')) {
      api.createRecord('5f45811f', component.options)
    } else {
      api.reload('5f45811f', component.options)
    }
    module.hot.accept("./RecaptchaNotice.vue?vue&type=template&id=5f45811f&scoped=true", function () {
      api.rerender('5f45811f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecaptchaNotice.vue"
export default component.exports